<template>
  <step :options="options" :resource="resource">
    <div v-for="attribute in attributes" :key="attribute" class="row mb-2">
      <div class="col">
        <form-field
          :id="resourceType + '-' + attribute"
          :label="resource.meta.labels[attribute] ?? trans(`models.${resourceType}.attributes.${attribute}`)"
          :name="attribute"
          :choices="resource.meta.options[attribute] ?? []"
          :field-type="resource.meta.elementTypes[attribute]"
          :value="localResource.data.attributes[attribute]"
          :element="resource.meta.elements[attribute] ? resource.meta.elements[attribute]['form'] ?? null : null"
          :options="options"
          @update:attribute="(value) => updateAttribute(attribute, value)"
          @update:toasts="$emit('update:toasts', $event)"
          @update:media="(media) => $emit('update:media', media, attribute)"
        ></form-field>
      </div>
    </div>
  </step>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';
import Step from '@kanrisha/components/Stepper/Step';
import FormField from '@kanrisha/components/Form/FormField';

export default {
  components: {
    FormField,
    Step,
  },
  props: {
    attributes: { type: Array, default: () => [] },
    options: {
      type: Object,
      default: () => ({
        title: 'Titel Schritt X',
        description: 'Es ist verboten, toten Kojoten die Hoden am Boden zu verknoten.',
      }),
    },
    resource: { type: Object, default: () => {} },
  },
  emits: ['updated:attribute', 'update:media'],
  setup(props, { emit }) {
    const resourceType = ref(props.resource.meta.resourceType);
    const localResource = ref(props.resource);

    const updateStep = (url, step) => {
      router.patch(url, { step });
    };

    const updateAttribute = (attribute, value) => {
      localResource.value.data.attributes[attribute] = value;

      if (
        localResource.value.form.sections &&
        localResource.value.form.sections['select'] &&
        localResource.value.form.sections['select'][attribute] === 'boolean'
      ) {
        localResource.value.data.attributes[attribute] = value === 'true' || value === true ? true : false;
      }

      emit('updated:attribute', attribute, value);
    };

    return {
      localResource,
      resourceType,
      updateAttribute,
      updateStep,
    };
  },
};
</script>
